
import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
    styleUrls: ['./ObjectsReport.css'],
    selector: 'ObjectsReport',
    templateUrl: './ObjectsReport.component.html',
})
export class ObjectsReportComponent extends PageBase {
    constructor(el: ElementRef) {
        super(el, "ObjectsReport");
    }
}
